import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

interface DimOverlayProps {
  children: ReactNode
  onClose: () => void
}

const DimOverlay = (props: DimOverlayProps) => {
  const { onClose, children } = props

  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null)
  const dimSection = useRef<HTMLDivElement>(null)

  const checkDimSection = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === dimSection.current) {
      document.body.style.overflow = 'unset'
      onClose()
    }
  }

  useEffect(() => {
    setPortalRoot(document.getElementById('modal-root'))

    if (!portalRoot) return
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  if (!portalRoot) return null

  return createPortal(
    <div
      className="tw-bg-dimmed-regular tw-inset-spacing-0 tw-fixed tw-z-[999999999] tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center"
      ref={dimSection}
      onClick={(e) => checkDimSection(e)}>
      {children}
    </div>,
    document.getElementById('modal-root') as HTMLElement
  )
}

export default DimOverlay
